import { Select } from 'mui-rff';
import { MenuItem } from '@mui/material';
import PropTypes from 'prop-types';

const DropDown = ({ options = [], ...props }) => {
  const listboxId = `menu-${props.name}`;

  return (
    <Select
      aria-controls={listboxId}
      {...props}
      slotProps={{
        popper: {
          id: listboxId,
          role: 'listbox',
        },
      }}
    >
      {options.map(option => (
        <MenuItem
          key={option.value}
          value={option.value}
          id={`${listboxId}-option-${option.value}`}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};
DropDown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
};

export default DropDown;
